var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-dialog',_vm._g({ref:"dialog",attrs:{"position":_vm.position,"persistent":_vm.persistent,"transition-show":_vm.transitionShow,"transition-hide":_vm.transitionHide}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }